// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3l8Ka","col":"Table_col__butOx","fulfillmentStatus":"Table_fulfillmentStatus__rkIe9","emailCol":"Table_emailCol__2aJVI"};